module.exports = __webpack_public_path__ + "img/death.96e350fc.png";